import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SharedModule } from '@aiwyn/shared';
import { CrlClientContact, CrlTeamMember } from '../../../../models';
import { getCxpContactInitials } from '../../../../shared';

/**
 * Right rail for the CRL list view (REQ-3 + PP-3642): a Details panel with a firm
 * Team section (owner starred + first, a Contact button that mails all team
 * members) and a Client access section (assignees + client owner). Mirrors the
 * deliverable details sidebar's initials-avatar rows. The "Due on" date is NOT
 * shown at the list level — per design it appears only on a selected item's
 * detail rail. Shows a skeleton/empty state until data is present.
 */
@Component({
  selector: 'cxp-crl-right-rail',
  templateUrl: './crl-right-rail.component.html',
  styleUrls: ['./crl-right-rail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class CrlRightRailComponent {
  readonly team = input<CrlTeamMember[]>([]);
  readonly clientContacts = input<CrlClientContact[]>([]);

  /** `mailto:` for the Contact button — every team member's email, comma-joined. */
  protected readonly contactAllHref = computed(() => {
    const emails = this.team()
      .map((member) => member.email)
      .filter(Boolean);
    return emails.length > 0 ? `mailto:${emails.join(',')}` : null;
  });

  initialsForTeam(member: CrlTeamMember): string {
    return getCxpContactInitials(member.name, member.email);
  }

  initialsForContact(contact: CrlClientContact): string {
    return getCxpContactInitials(contact.name, contact.email);
  }

  contactFallbackLabel(contact: CrlClientContact): string {
    if (contact.email) return contact.email;
    return contact.contactId != null ? `Contact #${contact.contactId}` : 'Invited guest';
  }
}
